<template>
    <BtnRate
        :on-vote="onVote"
        content-type="document"
        class="protected-auth protected-verified"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BtnRate from '@/components/BtnRate';
import { notifyError } from '@/components/FlashMessages';
import { rateDocument } from '@/api/gateway/legacy-api/document';

export default defineComponent({
    name: 'BtnRateDocument',
    components: {
        BtnRate,
    },
    props: {
        /**
         * id of the document to rate
         */
        documentId: {
            type: Number,
            required: true,
        },
    },
    methods: {
        onVote(value: number, reasonId?: number, comment?: string) {
            return rateDocument(this.documentId, value, reasonId, comment).then((response) => {
                if (!response.success) {
                    notifyError(this.$t('errors.unexpectedResponse'));
                    return undefined;
                }

                return {
                    avgScore: parseFloat(response.avg_star_score),
                    ratingsCount: response.ratings_count,
                };
            });
        },
    },
});
</script>

<style lang="scss" scoped></style>
